<template>
    <v-dialog
        content-class="statisticsInfoWrapper"
        :value="dialog"
        persistent
        transition="dialog-bottom-transition"
        width="890"
    >
        <div class="statisticsInfo">
            <div class="statisticsInfo_header">
                <span class="statisticsInfo_header-title">Work orders for <span class="gr">{{ currentDataInfo.currentDate | dateFormat }}</span></span>
                <button type="button" @click="closeDialog">
                    <svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
                </button>
            </div>
            <div class="statisticsInfo_body">
                <info
                    v-if="workOrdersStatisticsInfo"
                    :statisticsInfo="workOrdersStatisticsInfo"
                    title="Repaired"
                ></info>
                <info-table
                    v-if="workOrdersStatisticsFilter"
                    :filter="workOrdersStatisticsFilter"
                    :list-items="workOrdersStatisticsList"
                    :currentDataInfo="currentDataInfo"
                ></info-table>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
// components
import InfoTable from "@/components/Fleet/WorkOrdersStatistics/Analytics/StatisticsInfo/InfoTable/InfoTable";
import Info from "@/components/Fleet/WorkOrdersStatistics/Info/Info";

export default {
	name: "StatisticsInfo",
	components: {
		InfoTable,
		Info
	},
	props: {
		currentDataInfo: Object
	},
	computed: mapGetters([ 'workOrdersStatisticsInfo', 'workOrdersStatisticsList', 'workOrdersStatisticsFilter' ]),
	data: () => ({
		dialog: true
	}),
	methods: {
		closeDialog() {
			this.$emit('updateClose');
		}
	}
};
</script>

<style scoped lang="scss">
@import "statisticsInfo";
</style>
